import * as angular from 'angular';

import { TableResource } from '@mode/legacy/data-access-model-js';
import { TableState } from '@mode/legacy/types-app-state';

export namespace TableResFunctions {
  export function renderEmbed(table: TableState, runToken: string) {
    return angular.extend({}, table.currentView, {
      _dataset: table.queryToken,
      _token: table.token,
      _vizLink: getVizLink(table.resource),
      _vizReportRunLink: getVizReportRunLink(table.resource, runToken),
    });
  }

  export function getVizLink(table: TableResource): string | undefined {
    if (table && table.hasLink('report_viz_web')) {
      return table.links('report_viz_web').href;
    }
  }

  export function getVizReportRunLink(table: TableResource, reportRunToken: string) {
    return table.hasLink('report_run_viz_web')
      ? table.links('report_run_viz_web').$expand({ token: reportRunToken }, { excludeSSLPort: true })
      : '';
  }
}
